import { request } from '../auth/client';
import type {
  PaginatedResponse,
  PaymentBulkActionInput,
  PaymentCreateInput,
  PaymentListQuery,
  PaymentMethod,
  PaymentStatus,
  PaymentUpdateInput,
} from '@runik/shared';

export interface PaymentListRow {
  id: string;
  customerId: string;
  customerName: string;
  amount: string;
  currency: string;
  status: PaymentStatus;
  dueDate: string;
  paidAt: string | null;
  paymentMethod: PaymentMethod | null;
  description: string | null;
  invoiceNo: string;
  createdAt: string;
}

export const paymentsKey = (query?: Partial<PaymentListQuery>) =>
  ['payments', { ...(query ?? {}) }] as const;

export function listPayments(query: Partial<PaymentListQuery>) {
  const params = new URLSearchParams();
  if (query.page) params.set('page', String(query.page));
  if (query.limit) params.set('limit', String(query.limit));
  if (query.customerId) params.set('customerId', query.customerId);
  if (query.currency) params.set('currency', query.currency);
  if (query.from) params.set('from', query.from);
  if (query.to) params.set('to', query.to);
  if (query.status) {
    for (const s of query.status) params.append('status', s);
  }
  return request<PaginatedResponse<PaymentListRow>>(`/api/payments?${params.toString()}`);
}

export function createPayment(body: PaymentCreateInput) {
  return request<PaymentListRow>('/api/payments', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function updatePayment(id: string, body: PaymentUpdateInput) {
  return request<PaymentListRow>(`/api/payments/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function bulkPaymentAction(body: PaymentBulkActionInput) {
  return request<{ updated: string[]; skipped: { id: string; reason: string }[] }>(
    '/api/payments/bulk',
    { method: 'POST', body: JSON.stringify(body) },
  );
}
